import React, { useState, useEffect } from "react";
import { getTimeWorkedOnText } from "../../helpers";

const SessionHistory = ({ sessions }) => {
  let dummyHistoryData = [...sessions];

  const dummyTimeText = [
    "Today",
    "Yesterday",
    "2 days ago",
    "3 days ago",
    "1 week ago",
    "1 month ago",
  ];

  // Add value for time when the session was done
  //   TODO: Calculate this value from date StartedOn and current date
  dummyHistoryData = [
    ...dummyHistoryData.map((session, idx) => ({
      ...session,
      key: idx,
      _WhenTaskWasDone: dummyTimeText[idx],
    })),
  ];

  //   Show only 3 sessions
  const shownSessions = [...dummyHistoryData.filter((s, idx) => idx <= 2)];

  return (
    <div className="px-5 py-4 rounded-xl bg-white dark:bg-primary-dark border-2 border-slate-50  dark:border-transparent font-semibold shadow-lg cursor-pointer text-center">
      <div className="mb-2 text-lg">Past sessions</div>
      <div>
        {shownSessions && shownSessions.length !== 0 ? (
          shownSessions.map((session,idx) => (
            <div key={idx} className="flex justify-between mb-1 ">
              <p>{session._WhenTaskWasDone}</p>
              <p className="text-indigo-500">
                {getTimeWorkedOnText(session._TimeWorkedOn)}
              </p>
            </div>
          ))
        ) : (
          <p className="text-gray-400 font-normal py-4">
            No recorded past sessions
          </p>
        )}
      </div>
      <button className="cursor-no-drop bg-indigo-500 hover:bg-indigo-600 py-2 px-6 text-white rounded-full mt-3 ">
        View more
      </button>
    </div>
  );
};

export default SessionHistory;
